import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { switchMap, catchError, map, take } from 'rxjs/operators';

import { Crp } from 'modules/shared/models/crp.models';
import { CrpResponse } from 'store/models/crp.models';

import { CustomerService } from 'modules/core/services/customer.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { CrpService } from 'modules/core/services/crp.service';

@Injectable()
export class RiskAssessmentGuard implements CanActivate {

  constructor(private router: Router,
    private customerService: CustomerService,
    private crpService: CrpService,
    private snackBar: SnackbarService) { }

  getScreeningConclusionValidity(cusId: number): Observable<boolean> {
    return this.customerService.getCustomerCrps({
      customerId: cusId
    })
      .pipe(
        take(1),
        switchMap((res: CrpResponse) => this.crpService.getSearchableCrps(res.results)),
        map((crps: Crp[]) => {
          if (crps.length === 0) {
            return true;
          }
          return crps.every((crp: Crp) => crp.latestScreeningConclusion && !crp.latestScreeningConclusion.invalid);
        })
      );
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.getScreeningConclusionValidity(route.params.id).pipe(
      switchMap((screeningConclusionsValid: boolean) => {
        if (screeningConclusionsValid) {
          return of(true);
        } else {
          this.router.navigateByUrl(`customers/${route.params.id}`);
          this.snackBar.error('Please make sure all CRPs of this customer have valid screening conclusions before view risk report');
          return of(false);
        }
      }),
      catchError((error: any) => of(error))
    );
  }
}
